import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { popoverPadding } from "@iventis/styles/src/atomic-rules";
import { InteractiveElement } from "@iventis/styles/src/components";
import React, { PropsWithChildren } from "react";
import { styled } from "@iventis/styles";

interface ListItem {
    id: string;
    name: string;
    icon?: IconProp;
}

interface ListProps<TItem extends ListItem = ListItem> {
    listItems: TItem[];
    onButtonClick: (id: TItem) => void;
    className?: string;
}

function ListComponent<TItem extends ListItem = ListItem>({ listItems, onButtonClick, className }: PropsWithChildren<ListProps<TItem>>) {
    return (
        <List className={className}>
            {listItems.map((item) => (
                <InteractiveElement
                    key={item.id}
                    onClick={(event) => {
                        onButtonClick(item);
                        event.stopPropagation();
                    }}
                >
                    {item.icon && <FontAwesomeIcon icon={item.icon} />}
                    <span>{item.name}</span>
                </InteractiveElement>
            ))}
        </List>
    );
}

const List = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: ${popoverPadding.small};
`;
export default ListComponent;
